import { IReplyReviewRequest } from '../../interfaces/reply-review.interface'
import { IReplySugestionRequest } from '../../interfaces/reply-sugestion.interface'
import {
  IGoogleReviewsDetailRequest,
  IGoogleReviewsSummaryRequest,
  IGoogleReviewsTrendsRequest
} from '../../interfaces/google-reviews.interface'

export class GetReviews {
  static readonly type = '[reviews] Get Reviews'
}

export class ReplySugestion {
  static readonly type = '[reviews] Reply Sugestion'
  constructor(public payload: Partial<IReplySugestionRequest>) {}
}

export class ReplyReview {
  static readonly type = '[reviews] Reply Review'
  constructor(public payload: IReplyReviewRequest) {}
}

export class GetGoogleReviewsSummary {
  static readonly type = '[reviews] Get Google Reviews Summary'
  constructor(public payload: IGoogleReviewsSummaryRequest) {}
}

export class GetGoogleReviewsDetail {
  static readonly type = '[reviews] Get Google Reviews Detail'
  constructor(public payload: IGoogleReviewsDetailRequest) {}
}

export class GetGoogleReviewsTrends {
  static readonly type = '[Reviews] Get Google Reviews Trends'
  constructor(public payload: IGoogleReviewsTrendsRequest) {}
}
